import { TIMER_INTERVAL } from './config.js';

export function handleIntervalTemporizadorToast(tempo, onUpdate, onComplete) {
  let elapsed = 0;
  const interval = TIMER_INTERVAL;

  if (interval <= 0) {
    if (typeof onUpdate === 'function') {
      onUpdate(100);
    }
    if (typeof onComplete === 'function') {
      onComplete();
    }
    return;
  }
  
  const timer = setInterval(() => {
    elapsed += interval;
    const percent = Math.min((elapsed / tempo) * 100, 100);
    
    if (typeof onUpdate === 'function') {
      onUpdate(percent);
    }
    
    if (elapsed >= tempo) {
      clearInterval(timer);
      if (typeof onComplete === 'function') {
        onComplete();
      }
    }
  }, interval);
  
  return timer;
}